'use server'

import { getDefaultHeaders } from '@sylveraio/constants'
import { getBearerTokenServerAction } from '../getBearerTokenServerAction'

export async function ssrFetchWithBearer<T = any>(
  endpoint: string,
  token?: string,
): Promise<T> {
  const bearerToken = token ?? (await getBearerTokenServerAction())

  const response = await fetch(
    `${process.env['NEXT_PUBLIC_API_URL']}${endpoint}`,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        ...getDefaultHeaders(),
      },
    },
  )

  if (!response.ok) {
    throw new Error(
      `Failed to fetch ${endpoint}: ${response.status} ${response.statusText}`,
    )
  }

  return response.json()
}
